module.exports = __webpack_public_path__ + "static/media/pHome_article.7e092dcb.png";